<script>
	import { renderJson } from "./renderJSON";
	import { toggleAll } from "./toggleAll";

	export let strJson;
	export let componentId = "componentId";
	export let divIdPrefix = "object";
	export let widthClass =
		"overflow-auto max-w-[500px] md:max-w-[300px] lg:max-w-[600px]";
	export let spacingClass = "p-2 sm:p-4";
	export let borderClass = "border border-primary";
	export let otherClass = "rounded bg-gray-900 shadow-md";

	let jsonExplorer;

	export let isExpanded = false;

	$: (() => {
		if (jsonExplorer) {
			jsonExplorer.innerHTML = "";
			renderJson(strJson, jsonExplorer);
			toggleAll(isExpanded, jsonExplorer);
		}
	})();
</script>

<div
	id={`${divIdPrefix}-${componentId}`}
	bind:this={jsonExplorer}
	class={`${spacingClass} ${borderClass} ${otherClass} ${widthClass}`}
></div>
